<template>
  <label
    v-if="displayLabel"
    :id="`label--${id}`"
    :for="id"
    class="dependentdropdown__label"
  >
    <span
      v-if="!disabled && required"
      class="dependentdropdown__label-required"
    >
      *
    </span>
    {{ text }}
    <span
      v-if="message"
      class="dependentdropdown__label-message"
    >
      {{ message }}
    </span>
  </label>
</template>
<script>
  export default {
    name: 'Label',
    props: {
      id: {
        type: String,
        required: true
      },
      text: {
        type: String,
        required: true
      },
      message : {
        type    : String,
        default : null
      },
      disabled : {
        type    : Boolean,
        default : false
      },
      required : {
        type    : Boolean,
        default : false
      }
    },
    computed: {
      displayLabel() {
        return this.id && this.text;
      }
    }
  };
</script>

<style lang="scss">
.dependentdropdown {
  &__label {
    font-size: $size-small;
    font-weight: $font-weight-bold;
    margin-bottom: 5px;

    &-message {
      display: block;
      font-weight: normal;
      opacity: 0.8;
    }
  }
}
</style>
